import React from 'react';
import styled from 'styled-components';
import AppCSS from '../../../utils/styled';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Count = styled.span`
  ${AppCSS.fonts.label12Regular};
  color: ${AppCSS.colors.black};
`;

const WarningBadge = styled.span`
  padding: 2px 6px;
  ${AppCSS.radiuses.small};
  ${AppCSS.fonts.label12Bold};
  color: ${AppCSS.colors.white};
  background-color: ${AppCSS.colors.red};
`;

// Shows a count and, when `warn` is set, a small "Missing" badge next to it.
const CountWithWarning = ({ count, warn }: { count: number; warn?: boolean }) => (
  <Container>
    <Count>{count}</Count>
    {warn && <WarningBadge title={'Missing'}>Missing</WarningBadge>}
  </Container>
);

export default CountWithWarning;
